import React, { Fragment, useEffect, useState } from "react";
import Sidebar from "./Sidebar";
import Navbar from "./Navbar";
import { Outlet } from "react-router-dom";
import Footer from "./Footer";

const MainLayout = () => {
  const [toggled, setToggled] = useState(false);

  // Check the screen width and set 'toggled' state for mobile
  const handleResize = () => {
    if (window.innerWidth <= 768) {
      setToggled(true); // Open sidebar on mobile
    } else {
      setToggled(false); // Close sidebar on desktop
    }
  };

  useEffect(() => {
    handleResize(); // Set initial toggled state based on screen size
    window.addEventListener("resize", handleResize);

    // Cleanup the event listener
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <Fragment>
      <Sidebar toggled={toggled} />
      <Navbar toggled={toggled} setToggled={setToggled} />
      <div className={`content-area ${toggled ? "toggled" : ""}`}>
        <Outlet />
      </div>
      <Footer toggled={toggled} />
    </Fragment>
  );
};

export default MainLayout;
